export const SELF_ASSESSMENT_GENERAL_BUSINESS_FIELDS = [
  "selfAssessment_general_business_companyName",
  "selfAssessment_general_business_entityType",
  "selfAssessment_general_business_organizationType",
  "selfAssessment_general_business_locationCountry_id",
  "selfAssessment_general_business_certificationStatus",
  "selfAssessment_general_business_address",
  "selfAssessment_general_business_email",
  "selfAssessment_general_business_cellphone",
  "selfAssessment_general_business_wepsSignatory",
  "selfAssessment_general_business_unGlobalCompactMember",
  "selfAssessment_general_business_taxIdentificationNumber",
];
